module.exports = __webpack_public_path__ + "assets/img/yunzhuji_12.2815b97b.png";